import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { TenantInfo } from '../models/tenant-info';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class iAdminService {
  public apiBaseUrl: string;

  constructor(public http: HttpClient) {
    const config = environment;
    this.apiBaseUrl = config.iAdminApiBaseURL;
  }

  //#region TenantInfo
  public getTenant(): Observable<TenantInfo> {
    return this.http.get<TenantInfo>(`${this.apiBaseUrl}/Global/TenantInfo`);
  }
  //#endregion

  //#region Signature
  public getMySignature(): Observable<Blob> {
    return this.http.get<Blob>(`${this.apiBaseUrl}/Me/ImageSignature`, { responseType: 'blob' as 'json' });
  }

  public putMySignature(data): Observable<void> {
    const body = new FormData();
    body.append('UserSignature', data);
    return this.http.put<void>(`${this.apiBaseUrl}/Me/ImageSignature`, body);
  }
  //#endregion
}
